export default __webpack_public_path__ + "static/media/konstruktor_grafik.39ba0be9.jpg";